/*
|==========================================================================
| Dropdown Overflow Prevention
|==========================================================================
| 
| This script detects when dropdown menus would overflow off the right
| edge of the viewport and automatically repositions them to open on
| the left side instead. This is especially important for nested submenus.
|
|==========================================================================
|
*/

function positionDropdowns() {
  
  // Function to check if an element would overflow the viewport
  function wouldOverflowRight(element, submenu) {
    const rect = element.getBoundingClientRect();
    const submenuWidth = submenu.offsetWidth || 200; // Default min-width from CSS
    const viewportWidth = window.innerWidth;
    
    // Check if the submenu would overflow the right edge
    // For nested menus, check from the right edge of parent
    const potentialRightEdge = rect.right + submenuWidth;
    
    return potentialRightEdge > viewportWidth;
  }

  // Function to check if parent is already opening left
  function parentOpensLeft(element) {
    let parent = element.parentElement;
    while (parent) {
      if (parent.classList && parent.classList.contains('opens-left')) {
        return true;
      }
      if (parent.classList && parent.classList.contains('top-bar')) {
        break;
      }
      parent = parent.parentElement;
    }
    return false;
  }

  // Get all dropdown menu items with submenus
  const dropdownItems = document.querySelectorAll('.is-dropdown-submenu-parent');
  
  dropdownItems.forEach(function(item) {
    const submenu = item.querySelector('.is-dropdown-submenu');
    
    if (!submenu) return;
    
    // Temporarily make submenu visible to measure it
    const originalDisplay = submenu.style.display;
    const originalVisibility = submenu.style.visibility;
    submenu.style.visibility = 'hidden';
    submenu.style.display = 'block';
    
    // Check if it would overflow
    if (wouldOverflowRight(item, submenu)) {
      item.classList.add('opens-left');
      item.classList.remove('opens-right');
    } else {
      // If parent opens left and we have space on the right, keep opening left
      if (parentOpensLeft(item)) {
        // Check if we would overflow on the left if we continue opening left
        const rect = item.getBoundingClientRect();
        const submenuWidth = submenu.offsetWidth || 200;
        const potentialLeftEdge = rect.left - submenuWidth;
        
        if (potentialLeftEdge < 0) {
          // Would overflow left, so open right instead
          item.classList.remove('opens-left');
          item.classList.add('opens-right');
        } else {
          // Safe to open left
          item.classList.add('opens-left');
          item.classList.remove('opens-right');
        }
      } else {
        item.classList.add('opens-right');
        item.classList.remove('opens-left');
      }
    }
    
    // Restore original display
    submenu.style.display = originalDisplay;
    submenu.style.visibility = originalVisibility;
  });
}

// Run on page load
document.addEventListener('DOMContentLoaded', function() {
  positionDropdowns();
});

// Recalculate on window resize
let resizeTimer;
window.addEventListener('resize', function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
    positionDropdowns();
  }, 250);
});

// Re-run when Foundation is initialized (in case menus are dynamically added)
jQuery(document).on('init.zf.dropdown', function() {
  setTimeout(positionDropdowns, 100);
});

// Also run after Foundation fully loads
jQuery(document).ready(function() {
  setTimeout(positionDropdowns, 500);
});

